{
	"duration": {
		"hoursMinutes": "{hours} h {minutes} min",
		"hours": "{hours} h",
		"minutes": "{minutes} min"
	},
	"hero": {
		"metricTopics": "{count, plural, one {# topic} other {# topics}}",
		"metricTopicsHint": "{count, plural, one {in # section} other {in # sections}}",
		"metricTopicsHintPlain": "course outline",
		"metricDurationHint": "estimated workload",
		"metricLearners": "{count, plural, one {# learner} other {# learners}}",
		"metricLearnersHint": "started the course",
		"authorEyebrow": "Course author",
		"platformAuthor": "StudyHub",
		"anonymousAuthor": "No author listed",
		"authorCourses": "{count, plural, one {# course} other {# courses}} in the catalog"
	},
	"enroll": {
		"updated": "updated {date}",
		"paidNote": "One-time purchase · lifetime access",
		"start": "Start the course",
		"continue": "Continue the course",
		"buy": "Buy the course",
		"closed": "Enrollment closed",
		"closedReason": "The author has not opened access to this course yet.",
		"review": "Course in review",
		"reviewReason": "The course will appear in the catalog once the check is done. Until then nobody can enroll — including you.",
		"benefitsTitle": "What you get",
		"benefitOwnCopy": "Your own copy of the course — progress, notes and reviews stay yours",
		"benefitPlan": "The study plan adapts to your exam date",
		"benefitTutor": "Your personal tutor inside the course knows the whole syllabus",
		"benefitOffline": "Works offline in the iOS and Android app"
	},
	"kit": {
		"eyebrow": "What the course includes",
		"title": "Every topic arrives as a complete kit",
		"notesTitle": "Notes",
		"notesBody": "A structured breakdown of the topic: definitions, diagrams, formulas. Three levels of depth — from brief to detailed.",
		"notesNote": "{count, plural, one {# note} other {# notes}}",
		"notesNotePlain": "One note per topic",
		"flashcardsTitle": "Spaced-repetition cards",
		"flashcardsBody": "Spaced repetition decides what to show today: hard cards more often, easy ones less.",
		"flashcardsNote": "For every topic of the course",
		"quizzesTitle": "Topic quizzes",
		"quizzesBody": "Seven question types with mistake review. After the quiz — a list of weak spots and what to work on.",
		"quizzesNote": "With weak-spot review",
		"glossaryTitle": "Glossary",
		"glossaryBody": "Course terms with definitions and links between concepts. Hover hints right inside the notes.",
		"glossaryNote": "Built from the course materials",
		"tutorTitle": "Course AI tutor",
		"tutorBody": "Knows the whole syllabus. Ask about any topic — it explains, works through problems and checks your reasoning.",
		"tutorNote": "No topic limits",
		"audioTitle": "Audio version of a topic",
		"audioBody": "An 8–15 minute narration: a two-voice podcast or a lecture. Listen on the go, review before bed.",
		"audioNote": "On demand for any topic"
	},
	"flow": {
		"eyebrow": "How a session works",
		"title": "Three steps per topic",
		"stepsAria": "Topic route steps",
		"step1Label": "Get it",
		"step1Title": "Topic notes and help with what is unclear",
		"step1Body": "Key ideas, diagrams and terms in one place. Highlight an unclear passage and the tutor explains it right there, without leaving the page.",
		"step1RowNote": "Topic notes",
		"step1RowNoteBody": "Definitions, diagrams and formulas in working order",
		"step1RowGlossary": "Terms on hover",
		"step1RowGlossaryBody": "The definition pops up inside the notes",
		"step1RowTutor": "Explain the selection",
		"step1RowTutorBody": "The tutor unpacks the exact fragment, not the whole topic",
		"step2Label": "Check",
		"step2Title": "Cards for terms, a quiz for understanding",
		"step2Body": "The course shows more than a score: you see which sub-topics slipped and what to do about them.",
		"step2RowCards": "Term cards",
		"step2RowCardsBody": "Four answer ratings — the review interval is computed for you",
		"step2RowQuiz": "Topic quiz",
		"step2RowQuizBody": "Confidence is marked before answering, the review comes after",
		"step2RowWeak": "Weak spots",
		"step2RowWeakBody": "Sub-topics that slipped land in a separate list",
		"step3Label": "Close the gaps",
		"step3Title": "Weak-spot review and the topic back in the plan",
		"step3Body": "For weak spots the tutor walks through the reasoning, adds review cards and puts the topic back into the calendar.",
		"step3RowTutor": "Reasoning you can follow",
		"step3RowTutorBody": "You see the line of thought, not just the answer",
		"step3RowCards": "Review cards",
		"step3RowCardsBody": "Added exactly where you got it wrong",
		"step3RowPlan": "Back into the calendar",
		"step3RowPlanBody": "The topic is scheduled for the next working day"
	},
	"outcomes": {
		"eyebrow": "Outcome",
		"title": "What you will learn",
		"audienceTitle": "Who it is for",
		"prerequisitesTitle": "What you need beforehand"
	},
	"program": {
		"eyebrow": "Syllabus",
		"title": "Sections and topics",
		"summarySections": "{count, plural, one {# section} other {# sections}}",
		"summaryTopics": "{count, plural, one {# topic} other {# topics}}",
		"sectionMeta": "{count, plural, one {# topic} other {# topics}}",
		"topicMinutes": "{count} min"
	},
	"stats": {
		"eyebrow": "Course statistics",
		"title": "How others go through it",
		"lead": "Computed from people already studying: progress, pace and quiz results.",
		"completionValue": "{percent}%",
		"completionLabel": "finished the course",
		"completionHint": "{completed, plural, one {# learner has closed} other {# learners have closed}} every topic",
		"paceLabel": "typical pace",
		"paceValueDays": "{count, plural, one {# day} other {# days}}",
		"paceHint": "Median across those who finished the course",
		"accuracyValue": "{percent}%",
		"accuracyLabel": "average quiz accuracy",
		"accuracyHint": "Across final attempts",
		"hardestHint": "Hardest section — “{title}”"
	},
	"author": {
		"eyebrow": "Course author",
		"platformTitle": "A StudyHub course",
		"platformBody": "The course was prepared by the StudyHub team together with subject-matter experts.",
		"anonymousTitle": "No author listed",
		"anonymousBody": "This course was published anonymously — the author chose not to be named. It has passed the automated catalog policy check.",
		"coursesCount": "{count, plural, one {# course} other {# courses}} in the catalog",
		"link": "Author's site"
	},
	"faq": {
		"eyebrow": "Questions",
		"title": "Frequently asked"
	},
	"related": {
		"eyebrow": "Next",
		"title": "Similar courses",
		"topics": "{count, plural, one {# topic} other {# topics}}"
	},
	"finalCta": {
		"title": "Start the course today",
		"lead": "Your own copy of the course, a plan built around your date and a tutor that knows the whole syllabus.",
		"note": "You can enroll at any time — your progress is kept."
	},
	"start": {
		"title": "Start the course",
		"titleNamed": "Start the course “{title}”",
		"subtitle": "Set your pace — the plan will spread topics across your days.",
		"paceLabel": "When do you want to finish",
		"paceOwn": "At my own pace",
		"paceDeadline": "By a date",
		"paceOwnHint": "No deadline: topics are scheduled one after another.",
		"dateLabel": "Finish by",
		"minutesLabel": "Minutes per day",
		"minutesValue": "{count} min",
		"daysLabel": "Study days",
		"minDayHint": "Keep at least one day of the week.",
		"loadNote": "This pace is shared across all your courses and the calendar.",
		"forecast": "At this pace you'll finish around {date}",
		"forecastLate": "{date} is out of reach: at this pace the course ends {estimate}. Add minutes per day or more study days.",
		"forecastUnknown": "The course length isn't estimated yet — we'll show the date once the program is built.",
		"submit": "Start the course",
		"cancel": "Cancel",
		"started": "Course added — opening it",
		"alreadyStarted": "You're already taking this course",
		"deadlineError": "The course was created, but the finish date wasn't saved — set it in the calendar",
		"error": "Couldn't start the course",
		"levelLabel": "What level should the course adapt to?",
		"levelUnset": "Rather not say",
		"levels": {
			"beginner": "Beginner",
			"intermediate": "Intermediate",
			"advanced": "Advanced"
		},
		"audienceLabel": "Who is this for?",
		"audienceAdult": "An adult",
		"audienceOptions": {
			"3-7": "A child aged 3–7",
			"7-11": "A child aged 7–11",
			"11-14": "A teen aged 11–14",
			"14-17": "A teen aged 14–17"
		},
		"adaptNote": "The course programme stays exactly as its author wrote it — only the delivery adapts: explanations, tests, tutor and audio.",
		"wishesLabel": "Anything we should know?",
		"wishesPlaceholder": "For example: more practice, use real-world examples"
	},
	"paid": {
		"title": "Buying the course",
		"subtitle": "“{title}” is a paid course.",
		"unavailableBody": "Course payments are switched off right now. This course can't be bought yet — please try later.",
		"requiredBody": "The course opens after purchase. In-app payment isn't live yet — the button will appear here once it is.",
		"priceLabel": "Price",
		"note": "If you've already paid for this course, press “Buy course” again — access opens right away.",
		"close": "Got it",
		"browseFree": "Free courses"
	},
	"report": {
		"trigger": "Report",
		"menuTitle": "Course actions",
		"title": "Report this course",
		"subtitle": "Tell us what's wrong with “{title}”. A moderator will review it.",
		"reasonLabel": "Reason",
		"reasons": {
			"pii": "Personal data",
			"spam": "Spam or advertising",
			"hate_speech": "Hate speech or abuse",
			"csam": "Child sexual abuse material",
			"copyright": "Copyright infringement",
			"inappropriate": "Inappropriate content",
			"other": "Something else"
		},
		"commentLabel": "What exactly is wrong",
		"commentOptional": "optional",
		"commentPlaceholder": "Describe the problem: which section, which topic, what rule it breaks.",
		"commentCounter": "{count} of {max}",
		"note": "We never tell the author who reported. Learners who already started keep their access.",
		"submit": "Send report",
		"cancel": "Cancel",
		"sent": "Report sent — a moderator will review it",
		"error": "Couldn't send the report"
	},
	"review": {
		"pending": {
			"title": "The course is being checked",
			"body": "Until the check is done, only you can see this page: the course is not in the catalog or in search results, and nobody can enroll. This usually takes a couple of minutes."
		},
		"manual": {
			"title": "A person is reviewing the course",
			"body": "The automated check could not decide on its own, so a moderator will look at the course. You have not broken any rules — we are just waiting. For now, only you can see this page."
		},
		"rejected": {
			"title": "The course did not pass the check",
			"body": "The course does not meet the catalog rules and was not published. The reason is in your notification: fix it and publish the course again. If you think this is a mistake, contact support."
		}
	}
}
